/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './rx-calculator-formula.reducer';

export const RxCalculatorFormulaDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const rxCalculatorFormulaEntity = useAppSelector(state => state.rxCalculatorFormula.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="rxCalculatorFormulaDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.detail.title">RxCalculatorFormula</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.id">Id</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.name">Name</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.description">Description</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.description}</dd>
          <dt>
            <span id="formulaString">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.formulaString">Formula String</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.formulaString}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.entityId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.active">Active</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.timestampEntry}</dd>
          <dt>
            <span id="conceptId">
              <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.conceptId">Concept Id</Translate>
            </span>
          </dt>
          <dd>{rxCalculatorFormulaEntity.conceptId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.category">Category</Translate>
          </dt>
          <dd>{rxCalculatorFormulaEntity.category ? rxCalculatorFormulaEntity.category.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.categoryType">Category Type</Translate>
          </dt>
          <dd>{rxCalculatorFormulaEntity.categoryType ? rxCalculatorFormulaEntity.categoryType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.rxCalculatorFormula.entityType">Entity Type</Translate>
          </dt>
          <dd>{rxCalculatorFormulaEntity.entityType ? rxCalculatorFormulaEntity.entityType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/rx-calculator-formula" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/rx-calculator-formula/${rxCalculatorFormulaEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RxCalculatorFormulaDetail;
